import React from 'react';
import SystemNotification from './components/SystemNotifications/SystemNotification';
import Authorize from '@awp/components/Authorize';
import { Permissions } from '@awp/constants';

const Home = () => {
  return (
    <Authorize requires={[Permissions.ReadSysNotification]}>
      <SystemNotification />
    </Authorize>
  );
};
export default Home;
